import { IResourceComponentsProps, useTranslate } from '@pankod/refine-core'

import {
  Create,
  useForm
} from '@pankod/refine-antd'

import { definitions } from 'interfaces'
import { ShipmentsForm } from './form'

export const ShipmentCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<definitions['shipments']>()

  const t = useTranslate()

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
      title={t('shipments.titles.create')}
    >
      <ShipmentsForm
        formProps={formProps}
      />
    </Create>
  )
}
